export const translations = {
  sv: {
    componentheading: 'Våra priser och villkor för inrikesförsändelser för dig som direktbetalande kund?',
    deliveryscopeheading: 'Endast leveranser inom Sverige',
    resultlistheading: 'Några bra alternativ för dig',
    weightlabel: 'Vikt',
    maxweightlabel: 'Maxvikt',
    maxmeasurementlabel: 'Maxvolym',
    senddirectcta: 'Köp online',
    stampshopcta: 'Köp frimärken',
    message: '*Vid köp hos valfritt ombud',
    servicePointHeader: 'Eller hitta närmaste serviceställe',
    servicePointLink: 'Sök serviceställe eller brevlåda',
  },
  en: {
    componentheading: 'Our prices and terms and conditions for domestic shipments for you as a direct paying customer',
    deliveryscopeheading: 'Deliveries within Sweden only',
    resultlistheading: 'Some suitable options for you',
    weightlabel: 'Weight',
    maxweightlabel: 'Max weight',
    maxmeasurementlabel: 'Maximum measurement',
    senddirectcta: 'Buy Online',
    stampshopcta: 'Buy Stamps',
    message: 'When buying from any agent',
    servicePointHeader: 'Or find nearest service point',
    servicePointLink: 'Search letter-box or service point',
  },
  da: {
    componentheading: 'Vad vill du skicka?',
    deliveryscopeheading: 'Kun leveringer indenfor Sverige',
    resultlistheading: 'Some suitable options for you',
    weightlabel: 'Vægt',
    maxweightlabel: 'Max vægt',
    maxmeasurementlabel: 'Maks. Volumen',
    senddirectcta: 'Buy shipping in Send Direct',
    stampshopcta: 'Order home stamps from the webshop',
  },
  no: {
    componentheading: 'Vad vill du skicka?',
    deliveryscopeheading: 'Kun leveranser innen Sverige',
    resultlistheading: 'Some suitable options for you',
    weightlabel: 'Vekt',
    maxweightlabel: 'Maks vekt',
    maxmeasurementlabel: 'Maks volum',
    senddirectcta: 'Buy shipping in Send Direct',
    stampshopcta: 'Order home stamps from the webshop',
  },
  fi: {
    componentheading: 'Vad vill du skicka?',
    deliveryscopeheading: 'Toimitukset vain Ruotsin sisällä',
    resultlistheading: 'Some suitable options for you',
    weightlabel: 'Paino',
    maxweightlabel: 'Max paino',
    maxmeasurementlabel: 'Max äänenvoimakkuus',
    senddirectcta: 'Buy shipping in Send Direct',
    stampshopcta: 'Order home stamps from the webshop',
  },
};

export const markets = {
  se: {
    currency: 'kr',
  },
  dk: {
    currency: 'dk',
  },
  fi: {
    currency: ' €',
  },
  no: {
    currency: 'kr',
  },
};
